import { defineStore } from 'pinia'
import { datadogLogs } from '@datadog/browser-logs'
import { useAuthStore } from './auth'

export const useErrorsStore = defineStore('errors', {
  state: () => ({
    networkError: false,
    deprecatedCodeError: false,
  }),
  actions: {
    encouterNetworkError() {
      const authStore = useAuthStore()
      datadogLogs.logger.info(
        `Network error for: uid:${authStore.user?.id}/${authStore.user?.email}`,
      )
      this.networkError = true
    },
    encouterDeprecatedCodeError() {
      const authStore = useAuthStore()
      datadogLogs.logger.info(
        `Deprecated code error for: uid:${authStore.user?.id}/${authStore.user?.email}`,
      )
      this.deprecatedCodeError = true
    },
  },
})
